import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import usePageMeta from "@/hooks/usePageMeta";
import { faqs } from "@/mocks/guaData";
import HomeHero from "./components/HomeHero";
import HomeStats from "./components/HomeStats";
import HomeRankBoard from "./components/HomeRankBoard";
import HomeCategories from "./components/HomeCategories";
import HomeFeatured from "./components/HomeFeatured";
import HomeGrid from "./components/HomeGrid";
import HomeSubscribe from "./components/HomeSubscribe";
import HomeFaq from "./components/HomeFaq";

const SITE_URL = "https://hshplx.cn";

export default function Home() {
  const location = useLocation();

  usePageMeta({
    title: "热门吃瓜 - 今日热门吃瓜榜 | 最近吃瓜热点盘点与全网热议事件合集",
    description:
      "瓜田热榜聚合全网热议话题，实时汇总今日热门吃瓜榜、最近吃瓜热点盘点与全网热议事件合集，从娱乐八卦到社会焦点，一榜看尽最新鲜的瓜。",
    keywords:
      "热门吃瓜,今日热门吃瓜榜,热门吃瓜事件排行,最近吃瓜热点盘点,热门吃瓜热搜合集,全网热议",
    canonical: `${SITE_URL}/`,
    schema: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "瓜田热榜",
        url: `${SITE_URL}/`,
        inLanguage: "zh-CN",
        description: "全网热议话题聚合平台，实时汇总今日热门吃瓜榜与最近吃瓜热点盘点。",
        potentialAction: {
          "@type": "SearchAction",
          target: `${SITE_URL}/rank?q={search_term_string}`,
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "瓜田热榜",
        url: `${SITE_URL}/`,
        email: "hello@guatianrebang.example.com",
        description: "面向中文互联网用户的吃瓜热点聚合平台。",
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((item) => ({
          "@type": "Question",
          name: item.question,
          acceptedAnswer: { "@type": "Answer", text: item.answer },
        })),
      },
    ],
  });

  useEffect(() => {
    if (location.hash === "#categories") {
      const target = document.getElementById("categories");
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    } else if (!location.hash) {
      window.scrollTo({ top: 0 });
    }
  }, [location.hash]);

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="w-full">
        <HomeHero />
        <HomeStats />
        <HomeRankBoard />
        <HomeCategories />
        <HomeFeatured />
        <HomeGrid />
        <HomeSubscribe />
        <HomeFaq />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}